import { queryKeys } from '@/lib/query-keys';
import { apiClient } from '@borradh-workspace/api-client';
import { conversationSchema } from '@borradh-workspace/contracts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { Conversation } from '../types';

/**
 * Marks a conversation read for the whole team. Silent on purpose: this fires
 * as a side effect of opening a thread, so it must not toast — and if it fails
 * the conversation simply stays unread, which is the safe direction.
 */
export const useMarkConversationRead = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (id: string) =>
      apiClient.post<Conversation>(`conversations/${id}/read`, undefined, {
        schema: conversationSchema,
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: queryKeys.conversations.all(),
      });
    },
  });

  return {
    markConversationRead: mutation.mutate,
    isMarkingRead: mutation.isPending,
  };
};
